module.exports = __webpack_public_path__ + "static/media/patinetsTab.1061bb65.svg";